/**
 * Object for caching requests.
 *
 * @type {Object}
 * @private
 */
var cache = {};

/**
 * Fetches data using `d3.csv`. Implements a cache on top of the request so
 * repeated calls don't lead to additional XHR requests.
 *
 * @param  {String} url
 * @param  {Function} cb
 */
export default function getCSVData (url, cb) {
  if (cache && cache.hasOwnProperty(url)) {
    return cb(null, cache[url]);
  }

  d3.csv(url, function (err, data) {
    if (err) return cb(err);
    cache[url] = data;

    cb(null, data);
  });
}



/** WEBPACK FOOTER **
 ** ./utils/getCSVData.js
 **/